import { Text as ChakraText, type TextProps } from "@chakra-ui/react";

type Props = TextProps & {};

export const Typography = ({
  textStyle = "xs/font-normal",
  ...props
}: Props) => {
  return <ChakraText textStyle={textStyle} {...props} />;
};
